import { pngChartMaker } from '../pngChartMaker.tsx';
import { ApproachesToValueChartUnwrapped } from './ApproachesToValueChart.tsx';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './consts.ts';
import { ApproachesToValueChartProps } from './types.ts';

export const pngApproachesToValueChartMaker = async ({
  reconciliationData,
  shouldShowNewCostApproachPage,
}: ApproachesToValueChartProps): Promise<string | undefined> =>
  pngChartMaker(
    ApproachesToValueChartUnwrapped,
    {
      reconciliationData,
      disableAnimations: true,
      height: PNG_HEIGHT * IMAGE_FACTOR,
      shouldShowNewCostApproachPage,
    },
    PNG_WIDTH * IMAGE_FACTOR,
    PNG_HEIGHT * IMAGE_FACTOR,
  );
